/**
 * Prompt base para Generar Sketch (fashion flat / tech pack).
 * Orientado a vectorizar bien: lineas negras limpias, sin grises ni garabatos.
 * La vista (front / back / both) se añade con buildSketchPrompt.
 */
const SKETCH_BASE = [
  "Convierte la prenda de las imagenes de referencia en un dibujo tecnico plano de moda (fashion flat / tech pack) en blanco y negro.",
  "Fondo blanco puro (#FFFFFF). Solo lineas negras (#000000) de grosor uniforme y continuo: sin color, sin grises, sin sombreado, sin rellenos, sin degradados y sin sombras.",
  "Prenda en estado normal / reposo, simetrica, mangas completamente extendidas a los lados (no dobladas, no cruzadas, no metidas, no arremangadas).",
  "Traza con claridad lo esencial de la construccion: silueta CERRADA, costuras, paneles, bolsillos, cuello completo (borde exterior + abertura interior), bajo continuo de lado a lado, punos, cremallera, botones y pespunte.",
  "Cremallera (si existe): dibujo tecnico GEOMETRICO — exactamente 2 rieles verticales paralelos (lineas simples, sin relleno) y dientes = guiones horizontales cortos, todos iguales, espaciados regulares como un peine. PROHIBIDO en la cremallera: garabato, scribble, mancha negra, zigzag irregular, ruido, relleno del canal. Cursor = ovalo o rectangulo simple abajo o arriba.",
  "Pelo / borrego / shearling (si se ve): SOLO contorno limpio + muy pocos trazos cortos paralelos en el borde (hatch tipografico). Prohibido: garabatos, scribble, manchas, textura rellena, ruido.",
  "Pespunte: lineas limpias o guiones regulares, no puntos sueltos ni ruido.",
  "Prioriza lineas editables y legibles para Illustrator / VectorCraft / AutoTrace. Menos ruido, mas estructura. El dibujo debe poder trazarse a SVG de un solo trazo por linea.",
  "No inventes piezas que no esten. No cortes la silueta. Manten proporciones. Termina cuello y bajo.",
  "Sin maniqui, sin modelo, sin percha, sin suelo, sin texto, sin cotas ni anotaciones.",
].join(" ");

/**
 * @param {"front"|"back"|"both"} view
 */
export function buildSketchPrompt(view = "front") {
  if (view === "both") {
    return [
      SKETCH_BASE,
      "Una sola pagina / una sola imagen con las DOS vistas de la misma prenda una al lado de la otra.",
      "Izquierda: vista frontal. Derecha: vista trasera (espalda). Misma escala, alineadas horizontalmente, separadas por espacio en blanco.",
      "No generes dos paginas. No apiles las vistas en vertical. No dibujes solo una vista.",
    ].join(" ");
  }
  const v = view === "back" ? "back" : "front";
  const viewLine =
    v === "back"
      ? "Vista trasera (espalda) unicamente. Una sola prenda centrada. No dibujes la vista frontal."
      : "Vista frontal unicamente. Una sola prenda centrada. No dibujes la vista trasera.";
  return `${SKETCH_BASE} ${viewLine}`;
}

/** @deprecated prefer buildSketchPrompt("front") */
export const SKETCH_DEFAULT_PROMPT = buildSketchPrompt("front");

/** Una generacion por eleccion del dialog (both = una sola imagen con F+B). */
export function sketchViewsForChoice(choice) {
  if (choice === "both") return ["both"];
  if (choice === "back") return ["back"];
  return ["front"];
}
